import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CatalogueModelInfoModalComponent } from '../catalogue-model-info-modal/catalogue-model-info-modal.component';

@Component({
  selector: 'app-accordian-expansion-panel',
  templateUrl: './accordian-expansion-panel.component.html',
  styleUrl: './accordian-expansion-panel.component.css'
})
export class AccordianExpansionPanelComponent implements OnInit {

  @Input() panelData: any;
  @Input() cardHeader: string;
  @Input() tabType: string;
  @Input() routeData: any;

  constructor(private _dialog: MatDialog) { }

  ngOnInit() {
  }

  /**
   * Gets keys
   * @param obj 
   * @returns  
   */
  getKeys(obj: any) {
    return obj ? Object.keys(obj) : [];
  }

  /**
   * Opens popover
   * @param childData 
   */
  openPopover(childData: any) {
    this._dialog?.open(CatalogueModelInfoModalComponent, {
      data: { featureData: childData, routeData: this.routeData },
      position: {
        left: "65%",
        top: "7%"
      },
      panelClass: 'catalogue-model-info-modal',
      width: "35%"
    });
  }
}
